module.exports = __webpack_public_path__ + "img/dsj.675c8375.png";